import { ProgressCircleComponent } from './progress-circle.component';

export default angular
  .module('sfMobile.components.progress-circle', [
    'sfMobile.constants.numbers-scale',
  ])
  .component('sfProgressCircle', ProgressCircleComponent).name;
